module.exports = __webpack_public_path__ + "static/media/Jacob.d3874465.png";